const React = require('react')
const { domainSettings } = require('../../../../../config')
const Helpers = require('../../../../../_plugins/lib/helpers')
const createReactClass = require('create-react-class');

const EmailDiscountForm = createReactClass({

  getInitialState () {
    return {
      emailValue: '',
      h2Text: 'Sign up for an immediate discount',
      errorMsg: 'Email address',
      error: '',
      hideForm: false
    }
  },

  validateForm () {
    const { emailValue } = this.state
    if (emailValue === '') this.setState({ errorMsg: 'Please enter your email address', error: 'error'})
    const emailReg = new RegExp(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)
    const emailValid = emailReg.test(emailValue)
    Helpers.setCookie('Email', emailValue)
    return emailValid
  },

  submitForm () {
    const { emailValue } = this.state
    const { pageData } = this.props
    tracker.track('marketing', {
      marketing: {
        action: 'subscribe',
        agent_code: 'AZ385',
        country: 'uk',
        language: 'en',
        brand: 'AP',
        opt_in_message: `ap_exit_modal_signup_https://${domainSettings.domain}/${pageData.pageName}.html`,
        preferences: {
          frequency: 'fortnightly',
          method: ['email']
        }
      }
    })
    Helpers.setCookie('exit_discount_modal_already_seen', '1')
    Helpers.setCookie('exit_discount_modal_Email', emailValue)
    // TEMP TECH DEBT FIX - waiting on responsys to get fixed!
    window.location.href = '?agent=AZ385'
    // this.setState({
    //   h2Text: 'Thanks. We’ve sent you an email<br/> Please check your inbox and click the verify button.',
    //   hideForm: true
    // })
  },

  handleChange (event) {
    this.setState({emailValue: event.target.value, error: ''})
  },

  handleSubmit (e) {
    e.preventDefault()
    this.validateForm() && this.submitForm()
  },

  render () {
    const { h2Text, hideForm } = this.state
    const { pageData } = this.props
    return (
      <div className='modal-exit-discount-content emailPopup'>
        <div className='modal-exit-discount-content-inner'>
          <h2 className='emailHead' dangerouslySetInnerHTML={{ __html: h2Text }} />
          {!hideForm && (
          <form acceptCharset='UTF-8' action='https://email.holidayextras.co.uk/pub/rf' id='email-signup' onSubmit={this.handleSubmit} >
            <div className='form-item webform-component webform-component-email webform-component--email-address'>
              <input className='form-control required' id='email-Id' type='email' name='EMAIL_ADDRESS_' value={this.state.emailValue} placeholder={this.state.errorMsg} onChange={this.handleChange} data-error={this.state.error} />
              <input type='hidden' name='AP' value='1' />
              <input type='hidden' name='AGENT' value='AZ385' />
              <input type='hidden' name='STAMP' value={new Date().getTime()} />
              <input type='hidden' name='EMAIL_PERMISSION_STATUS_' value='I' />
              <input type='hidden' name='EMAIL_DELIVERABILITY_STATUS_' value='D' />
              <input type='hidden' name='LANGUAGE' value='EN' />
              <input type='hidden' name='REFERRER' value={'https://' + domainSettings.domain + '/' + pageData.pageName + '.html'} />
              <input type='hidden' name='_ri_' value='X0Gzc2X%3DYQpglLjHJlYQGiPIy5uKfPlrNGAkzb9G4zeKJg3zcoUfuYCehqHzfhRoVwjpnpgHlpgneHmgJoXX0Gzc2X%3DYQpglLjHJlYQGrwciWW7Ocn7TT44aCcS1qbg3zcoUfuYCehqHzfhRo' />
            </div>
            <input className='btn btn-lg btn-primary emailSubmit' name='op' type='submit' value='Apply Discount' data-hxtrack-name='email-popup-subscribe' />
          </form>
              )}
        </div>
      </div>
    )
  }
})

module.exports = EmailDiscountForm




// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/modals/EmailDiscountForm.jsx